import { render, staticRenderFns } from "./DettaglioRisposta.vue?vue&type=template&id=01699697&"
import script from "./DettaglioRisposta.vue?vue&type=script&lang=js&"
export * from "./DettaglioRisposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports